const steps = [
  {
    number: '01',
    title: 'Elige tu plan',
    desc: 'Selecciona Basico o Prime segun cuantas personas quieres registrar. El registro se hace desde tu celular.',
  },
  {
    number: '02',
    title: 'Agrega familiares',
    desc: 'Registra a las personas que quedaran dentro de tu membresia y manten tus datos visibles en la app.',
  },
  {
    number: '03',
    title: 'Mantén tu membresia activa',
    desc: 'Paga mes a mes desde la app o con las opciones disponibles. Tu estado y pagos quedan claros.',
  },
  {
    number: '04',
    title: 'Coverly coordina cuando se necesita',
    desc: 'Cuando llega el momento, Coverly coordina con funerarias aliadas de prestigio disponibles en la zona del cliente.',
  },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="bg-white py-14 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex rounded-full border border-[#DDD8F5] bg-[#F7F6FF] px-4 py-2 text-xs font-black uppercase tracking-wide text-[#534AB7]">
            Simple y claro
          </span>
          <h2 className="mt-5 font-title text-3xl font-black leading-tight tracking-[-0.035em] text-[#171421] md:text-5xl">
            Como funciona Coverly
          </h2>
          <p className="mt-5 text-base leading-8 text-[#625D70] md:text-lg">
            El mecanismo es simple: una membresia mensual, familiares registrados y coordinacion cuando corresponda solicitar los servicios del plan.
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-4">
          {steps.map((step) => (
            <article key={step.number} className="rounded-[28px] border border-[#E8E4F8] bg-[#FBFAFF] p-6">
              <p className="text-sm font-black text-[#534AB7]">{step.number}</p>
              <h3 className="mt-5 text-xl font-black text-[#242033]">{step.title}</h3>
              <p className="mt-3 text-sm leading-7 text-[#6B6578]">{step.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
